import { BaseSizeEnum as m } from "./common.js";
const o = {
  [m.Small]: [40, 24],
  // [width, height]
  [m.Medium]: [56, 32]
};
export {
  o as SWITCH_SIZE_CONFIGURATION
};
//# sourceMappingURL=switch.js.map
